import { v4 as uuid } from 'uuid'

export type CookieName =
  | 'GTO_LANGUAGE'
  | 'GTO_REFERRER'
  | 'GTO_G1'
  | 'GTO_GCLID'
  | 'GTO_trackAffil'
  | 'GTO_APP_UID'
  | 'GTO_AFFILIATE_ID'
  | 'GTO_TRITON_ANSWERS'
  | 'GTO_TRITON_BOARD'

export const getCookie = (cname: CookieName): string => {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i]?.trim() || ''
    if (c.startsWith(name)) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const setCrossDomainCookie = (
  name: CookieName,
  content: string,
  exdays: number = 30,
): void => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  const str = `${name}=${content};${expires};path=/;Secure;domain=.gtowizard.com`
  document.cookie = str
}

export const deleteCookie = (name: CookieName): void => {
  setCrossDomainCookie(name, 'deleteme', 0)
}

export const generateAppUID = (): string => uuid()

export interface BrowserVersion {
  name: string
  version: string
}

export const getBrowserVersion = (): BrowserVersion => {
  const ua = navigator.userAgent
  let tem: RegExpExecArray | Array<string> | null
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

  if (M[1] && /trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return { name: 'IE', version: tem[1] || '' }
  }

  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
    if (tem != null && tem[1] && tem[2]) {
      return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] }
    }
  }

  M = M[2] ? [M[1]!, M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]?.toString() || '')
  }

  return { name: M[0]!, version: M[1] || '' }
}
